import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FileUploadOutlined } from "@mui/icons-material";

import './VesselRevisionGridPage.scss';

import { Button, Icon } from "abs-ui-components";

import VesselRevisionGridTable from "../../../components/Seemp/VesselRevisionGridTable/VesselRevisionGridTable"
import { getQueryData } from "../../../services/utilities";
import { emitToasterMsg } from "../../../services/toasterUtility";

const VesselRevisionGridPage = () => {
    const params = useParams();
    const navigate = useNavigate();
    const imoNumber = params.imoNumber;
    // const imoNumber = useSelector((state) => state.seemp.imoNumber);
    let [vesselName, setVesselName] = useState(useSelector((state) => state.seemp.vesselName));
    const [hasRevisionData, setHasRevisionData] = useState(false);

    useEffect(() => {
        if (!vesselName) {
            getVesselDetails();
        }
    }, []);

    useEffect(() => {
    }, [hasRevisionData]);

    const getVesselDetails = () => {
        let requestPayload = {
            entity: "SEEMPDTL",
            query: {
                conditions: [
                    {
                        type: "and",
                        queries: [
                            {
                                field: "ImoNumber",
                                operation: "contains",
                                value: imoNumber,
                            },
                        ],
                    },
                ],
            },
            includeProperties: [
                "VesselName",
            ],
            "pagination": {
                "page": 1,
                "pageSize": 25
            }
        };

        getQueryData(requestPayload).then((response) => {
            if (response.data.Data) {
                setVesselName(response.data.Data[0].VesselName);
            }
        }).catch((error) => {
            emitToasterMsg(
                "error",
                "Vessel Revision",
                error.response.data.errorMessage
            );
        });
    }

    return (
        <div className="revision-grid-wrapper">
            <div className="revision-grid-actions">
                <label className="revision-vessel-name">{vesselName}</label>
                <label className="revision-imo-number"><span className="imo-bold">IMO: </span> {imoNumber}</label>
                <div className="d-flex justify-content-between">
                    <Button
                        variant="tertiary"
                        startIcon={<Icon icon="arrow_back" />}
                        className="mr-4"
                        onClick={() => {
                            navigate("/seemp");
                        }}
                    >
                        Return back to SEEMP III Table
                    </Button>
                    <div className="d-flex">
                        <Button
                            startIcon={<FileUploadOutlined />}
                            className="mr-4"
                            disabled={hasRevisionData}
                            onClick={() => console.info('Upload PDF Clicked')}
                        >
                            Upload PDF
                        </Button>
                        <Button
                            startIcon={<FileUploadOutlined />}
                            disabled={hasRevisionData}
                            onClick={() => console.info('Upload Digital Clicked')}
                        >
                            Upload Digital
                        </Button>
                    </div>
                </div>
            </div>
            <VesselRevisionGridTable hasRevisionData={setHasRevisionData} />
        </div>
    )
}

export default VesselRevisionGridPage